var map = {
	"./bos.css": "./src/config/bos.css",
	"./djt.css": "./src/config/djt.css",
	"./lna.css": "./src/config/lna.css",
	"./pbi.css": "./src/config/pbi.css",
	"./syd.css": "./src/config/syd.css"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/config sync recursive ^\\.\\/.*\\.css$";